<template>
  <v-app id="app_create_user_role">
    <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
      <v-progress-circular color="green" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row>
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">CREATE USER ROLES</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            These created user roles help you grant permissions for functions.
          </p>
        </v-col>

        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical />
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <template v-slot:title>
          <p class="custom_page_component_main_title pa-3">Create new user roles</p>
        </template>

        <v-divider thickness="2" />

        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col cols="12">
                    <v-alert color="#F0F0F0" prominent density="default" border="left"
                      text="These user roles help you grant permissions and assign related functions to users in the system.">
                      <template v-slot:prepend>
                        <v-icon color="orange" size="x-large">mdi-alert</v-icon>
                      </template>
                    </v-alert>
                  </v-col>

                  <v-col cols="12">
                    <p class="custom_page_main_sub_title">
                      <strong>SELECT USER CATEGORY</strong>
                    </p>
                    <v-divider class="mt-4" />
                  </v-col>

                  <v-col cols="4">
                    <v-checkbox v-model="selectedUsers" value="Web User" color="#05146F" hide-details label="WEB"
                      @update:model-value="onUserCategoryChange" />
                  </v-col>

                  <v-col cols="4">
                    <v-checkbox v-model="selectedUsers" value="Mobile User" color="#05146F" hide-details label="MOBILE"
                      @update:model-value="onUserCategoryChange" />
                  </v-col>

                  <v-col cols="4">
                    <v-checkbox :model-value="isBothSelected" @update:model-value="toggleBoth" color="#05146F"
                      hide-details label="WEB & MOBILE" />
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-text-field v-model="selectedItem.user_role" label="Role type *" placeholder="Type User Role Here"
                  variant="outlined" @input="validateUserRole" density="comfortable" color="#BB0000" :counter="20"
                  maxlength="20" />

                <p v-if="errorMessage" class="mt-0" style="color: red;" type="error">
                  {{ errorMessage }}
                </p>

                <v-textarea v-model="selectedItem.user_role_description" class="mt-2" label="Description *"
                  placeholder="Type user description here, Max 300 characters" required rows="6" variant="outlined"
                  color="#BB0000" :counter="300" maxlength="300" />
              </v-col>
            </v-row>
          </v-form>

          <!-- PERMISSIONS TABLE - Only show when Web User is selected -->
          <v-row class="mt-4" v-if="showPermissionsTable">
            <v-col cols="12">
              <v-expansion-panels variant="accordion" class="custom_card_box" elevation="0">
                <v-expansion-panel>
                  <v-expansion-panel-title>
                    <span class="font-weight-bold">User Permissions</span>
                  </v-expansion-panel-title>

                  <v-expansion-panel-text>
                    <v-card class="custom_card_box" elevation="0" border="sm opacity-1" rounded="lg">
                      <v-card-text class="pa-0">
                        <div class="permissions-table">
                          <div class="permissions-head">
                            <div class="col-name">Module</div>
                            <div class="col-perm">Read</div>
                            <div class="col-perm">Write</div>
                            <div class="col-perm">Delete</div>
                          </div>

                          <!-- LOOP THROUGH GROUPS AND ITEMS -->
                          <div v-for="item in permissionsItems" :key="item.key">

                            <!-- TYPE: SINGLE (Main component with access) -->
                            <div v-if="item.type === 'single'" class="permissions-row">
                              <div class="col-name d-flex align-center">
                                <span class="font-weight-medium">{{ item.title }} <b>(Main)</b></span>
                              </div>
                              <div class="col-perm">
                                <v-checkbox-btn v-model="item.permissions.read" class="checkbox" color="#800080"
                                  @update:model-value="handlePermissionChange(item, 'read')" />
                              </div>
                              <div class="col-perm">
                                <v-checkbox-btn v-model="item.permissions.write" class="checkbox" color="#800080"
                                  @update:model-value="handlePermissionChange(item, 'write')" />
                              </div>
                              <div class="col-perm">
                                <v-checkbox-btn v-model="item.permissions.delete" class="checkbox" color="#800080"
                                  @update:model-value="handlePermissionChange(item, 'delete')" />
                              </div>
                            </div>

                            <!-- TYPE: GROUP (Main component header, Sub-components have access) -->
                            <template v-else-if="item.type === 'group'">
                              <!-- Header Row (No direct permissions for group header as per request) -->
                              <div class="permissions-row" style="background-color: #f9f9f9;">
                                <div class="col-name d-flex align-center">
                                  <span class="font-weight-bold text-uppercase" style="color:#05146F;">{{ item.title
                                  }}</span>
                                </div>
                                <div class="col-perm"></div>
                                <div class="col-perm"></div>
                                <div class="col-perm"></div>
                              </div>

                              <!-- Child Rows -->
                              <div v-for="child in item.children" :key="child.key" class="permissions-row"
                                style="border-bottom: 1px dotted #e0e0e0;">
                                <div class="col-name d-flex align-center pl-8">
                                  <!-- Indented child title -->
                                  <span>{{ child.title }}</span>
                                </div>

                                <div class="col-perm">
                                  <v-checkbox-btn v-model="child.permissions.read" class="checkbox" color="#800080"
                                    @update:model-value="handlePermissionChange(child, 'read')" />
                                </div>

                                <div class="col-perm">
                                  <v-checkbox-btn v-model="child.permissions.write" class="checkbox" color="#800080"
                                    @update:model-value="handlePermissionChange(child, 'write')" />
                                </div>

                                <div class="col-perm">
                                  <v-checkbox-btn v-model="child.permissions.delete" class="checkbox" color="#800080"
                                    @update:model-value="handlePermissionChange(child, 'delete')" />
                                </div>
                              </div>
                            </template>
                          </div>
                          <!-- END LOOP -->

                        </div>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider thickness="2" />

        <v-card-actions class="float-end">
          <v-btn size="x-large" style="background-color: #800080; color: white;" @click="createNewRole">
            Create User role
          </v-btn>
          <v-btn size="x-large" class="custom_btn_secondary" @click="backPageRoute()">Cancel</v-btn>
        </v-card-actions>
      </v-card>

      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
        :top="snackAlert.snackBarTop" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: "CreateUserRole",
  data() {
    return {
      centerLoading: false,

      // This will hold the hierarchical structure
      permissionsItems: [],

      // Config definition with IDs assigned to all components
      mainNavModules: [
        // --- Single Access Main Components ---
        { key: "dashboard", title: "Dashboard", dashboard_id: 1, type: "single" },
        { key: "area", title: "Area Management", dashboard_id: 4, type: "single" },
        { key: "dailySummary", title: "Daily Summary Report", dashboard_id: 11, type: "single" },
        { key: "userLogs", title: "User Logs", dashboard_id: 12, type: "single" },

        // --- Group Components with Sub Component IDs ---
        {
          key: "lead",
          title: "New Visit Management",
          dashboard_id: 2,
          type: "group",
          children: [
            { key: "add_leads", title: "Add New Visit", dashboard_id: 2 },
            { key: "lead_list", title: "New Visit List", dashboard_id: 2 },
            { key: "leads_approval", title: "New Visit for Approval", dashboard_id: 2 },
            { key: "approved_leads", title: "Approved New Visit", dashboard_id: 2 },
            { key: "rejected_leads", title: "Rejected New Visit", dashboard_id: 2 },
          ],
        },
        {
          key: "user",
          title: "User Management",
          dashboard_id: 3,
          type: "group",
          children: [
            { key: "user_registration", title: "User Registration", dashboard_id: 3 },
            { key: "user_list", title: "User List", dashboard_id: 3 },
            { key: "create_user_role", title: "Create User Role", dashboard_id: 3 },
            { key: "user_role_list", title: "User Role List", dashboard_id: 3 },
          ],
        },
        {
          key: "dealer",
          title: "Dealer Management",
          dashboard_id: 5,
          type: "group",
          children: [
            { key: "dealer_management", title: "Dealer Registration", dashboard_id: 5 },
            { key: "dealer_list", title: "Dealer List", dashboard_id: 5 },
          ],
        },
        {
          key: "product",
          title: "Product Management",
          dashboard_id: 6,
          type: "group",
          children: [
            { key: "add_product", title: "Add Product", dashboard_id: 6 },
            { key: "product_list", title: "Product List", dashboard_id: 6 },
            { key: "add_category", title: "Add Category", dashboard_id: 6 },
            { key: "category_list", title: "Category List", dashboard_id: 6 },
          ],
        },
        {
          key: "route",
          title: "Route Management",
          dashboard_id: 7,
          type: "group",
          children: [
            { key: "create_routes", title: "Create Routes", dashboard_id: 7 },
            { key: "routes_list", title: "Routes List", dashboard_id: 7 },
          ],
        },
        {
          key: "collection",
          title: "Collection Management",
          dashboard_id: 8,
          type: "group",
          children: [
            { key: "collection_bulk_upload", title: "Collection Bulk Upload", dashboard_id: 8 },
            { key: "total_collection", title: "Total Collection", dashboard_id: 8 },
            { key: "overdue_collection", title: "Overdue Collection", dashboard_id: 8 },
            { key: "approved_overdues", title: "Approved Overdues", dashboard_id: 8 },
            { key: "CollectionNotify", title: "Collection Notify List", dashboard_id: 8 },
          ],
        },
        {
          key: "tracking",
          title: "Tracking Management",
          dashboard_id: 9,
          type: "group",
          children: [
            { key: "live_tracking", title: "Live Tracking", dashboard_id: 9 },
            { key: "tracking_history", title: "Tracking History", dashboard_id: 9 },
          ],
        },
        {
          key: "bulkUpload",
          title: "BulkUpload Management",
          dashboard_id: 13,
          type: "group",
          children: [
            { key: "Bulk_Upload", title: "Bulk Upload", dashboard_id: 13 },
          ],
        },
        {
          key: "paymentReversal",
          title: "Payment Reversal",
          dashboard_id: 10,
          type: "group",
          children: [
            { key: "pending_reversals", title: "Pending Reversals", dashboard_id: 10 },
            { key: "approved_reversals", title: "Approved Reversals", dashboard_id: 10 },
          ],
        },
      ],

      selectedUsers: [],

      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackMessage: "",
        snackBarRight: false,
        snackBarTop: true,
      },

      selectedItem: {
        user_role: null,
        user_role_description: "",
      },

      userRolesCheckDetails: { name: [] },
      errorMessage: "",
    };
  },

  computed: {
    isBothSelected() {
      return this.selectedUsers.includes("Web User") && this.selectedUsers.includes("Mobile User");
    },

    // Show permissions table only when Web User is selected (either alone or with Mobile User)
    showPermissionsTable() {
      return this.selectedUsers.includes("Web User");
    },

    // Show mobile message when only Mobile User is selected (no Web User)
    showMobileMessage() {
      return this.selectedUsers.includes("Mobile User") && !this.selectedUsers.includes("Web User");
    },
  },

  mounted() {
    this.getDashboardPermissions();
    this.getAllCreatedUserRoles();
  },

  methods: {
    // -------- category selection --------
    toggleBoth() {
      if (this.isBothSelected) {
        this.selectedUsers = this.selectedUsers.filter(
          (user) => user !== "Web User" && user !== "Mobile User"
        );
      } else {
        if (!this.selectedUsers.includes("Web User")) this.selectedUsers.push("Web User");
        if (!this.selectedUsers.includes("Mobile User")) this.selectedUsers.push("Mobile User");
      }
    },

    // Handle user category change - reset permissions when switching to mobile only
    onUserCategoryChange() {
      // If Mobile User is selected but Web User is not, reset all permissions
      if (this.selectedUsers.includes("Mobile User") && !this.selectedUsers.includes("Web User")) {
        this.resetAllPermissions();
      }
    },

    // Reset all permissions to false
    resetAllPermissions() {
      this.permissionsItems.forEach((item) => {
        if (item.type === 'single' && item.permissions) {
          item.permissions.read = false;
          item.permissions.write = false;
          item.permissions.delete = false;
        }
        if (item.type === 'group' && item.children) {
          item.children.forEach(child => {
            if (child.permissions) {
              child.permissions.read = false;
              child.permissions.write = false;
              child.permissions.delete = false;
            }
          });
        }
      });
    },

    // -------- ui helpers --------
    showSnackbar(message, color) {
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
      this.snackAlert.snackbar = true;
    },

    validateUserRole() {
      // Updated regex to allow letters, numbers, and spaces
      const textRegex = /^[a-zA-Z0-9\s]*$/;
      if (!textRegex.test(this.selectedItem.user_role)) {
        this.selectedItem.user_role = (this.selectedItem.user_role || "").replace(/[^a-zA-Z0-9\s]/g, "");
      }
      this.chechalreadyHasUserRole();
    },

    chechalreadyHasUserRole() {
      if (
        Array.isArray(this.userRolesCheckDetails.name) &&
        this.selectedItem.user_role &&
        this.userRolesCheckDetails.name.includes(this.selectedItem.user_role.trim())
      ) {
        this.errorMessage = "User role already exists";
      } else {
        this.errorMessage = "";
      }
    },

    // -------- permission rules --------
    enforceRules(target, permissionType) {
      if (permissionType === "write" && target.write) {
        target.read = true;
      }

      if (permissionType === "delete" && target.delete) {
        target.read = true;
        target.write = true;
      }

      if (!target.read) {
        target.write = false;
        target.delete = false;
      }

      if (!target.read && !target.write) {
        target.delete = false;
      }
    },

    handlePermissionChange(item, permissionType) {
      if (item.permissions) {
        this.enforceRules(item.permissions, permissionType);
      }
    },

    // -------- data load --------
    getDashboardPermissions() {
      // Just initialize structure. We rely on the local mainNavModules configuration
      // because it contains the exact hierarchy and IDs we need.
      this.initializePermissionsStructure();
    },

    initializePermissionsStructure() {
      this.permissionsItems = this.mainNavModules.map((nav) => {
        const item = {
          ...nav,
          // If single, it gets directly editable permissions
          permissions: nav.type === 'single' ? { read: false, write: false, delete: false } : null
        };

        // If group, the children get editable permissions
        if (nav.type === 'group' && nav.children) {
          item.children = nav.children.map(child => ({
            ...child,
            permissions: { read: false, write: false, delete: false }
          }));
        }

        return item;
      });
    },

    // -------- payload generation (FIXED: Changed to match backend expectations) --------
    buildPermissionsPayload() {
      // If Web User is not selected, return empty array (no permissions)
      if (!this.selectedUsers.includes("Web User")) {
        return [];
      }

      const rows = [];

      this.permissionsItems.forEach((item) => {
        // Case 1: Single item
        if (item.type === 'single') {
          // Only add if at least one permission is true
          if (item.permissions.read || item.permissions.write || item.permissions.delete) {
            rows.push({
              dashboard_id: item.dashboard_id,
              module: item.title,
              read_premission: item.permissions.read ? 1 : 0,    // Typo preserved: read_premission
              write_premission: item.permissions.write ? 1 : 0,  // Typo preserved: write_premission
              delete_premission: item.permissions.delete ? 1 : 0, // Typo preserved: delete_premission
            });
          }
        }

        // Case 2: Group item children
        if (item.type === 'group' && item.children) {
          item.children.forEach(child => {
            // Only add if at least one permission is true
            if (child.permissions.read || child.permissions.write || child.permissions.delete) {
              rows.push({
                dashboard_id: child.dashboard_id,
                module: child.title,
                read_premission: child.permissions.read ? 1 : 0,    // Typo preserved: read_premission
                write_premission: child.permissions.write ? 1 : 0,  // Typo preserved: write_premission
                delete_premission: child.permissions.delete ? 1 : 0, // Typo preserved: delete_premission
              });
            }
          });
        }
      });

      return rows;
    },

    validateForm() {
      // Validate user category
      if (!this.selectedUsers || this.selectedUsers.length === 0) {
        this.showSnackbar("Please select a user category.", "error");
        return false;
      }

      // Validate role type
      if (!this.selectedItem.user_role || this.selectedItem.user_role.trim() === "") {
        this.showSnackbar("Role type is required.", "error");
        return false;
      }

      // Validate role type length
      if (this.selectedItem.user_role.length > 20) {
        this.showSnackbar("Role type cannot exceed 20 characters.", "error");
        return false;
      }

      // Validate role type characters
      const allowedCharsRegex = /^[a-zA-Z0-9\s]+$/;
      if (!allowedCharsRegex.test(this.selectedItem.user_role)) {
        this.showSnackbar("Role type can only contain letters, numbers, and spaces.", "error");
        return false;
      }

      // Validate description
      if (!this.selectedItem.user_role_description || this.selectedItem.user_role_description.trim() === "") {
        this.showSnackbar("Description is required.", "error");
        return false;
      }

      // Validate description length
      if (this.selectedItem.user_role_description.length > 300) {
        this.showSnackbar("Description cannot exceed 300 characters.", "error");
        return false;
      }

      // Validate permissions only if Web User is selected
      if (this.selectedUsers.includes("Web User")) {
        const perms = this.buildPermissionsPayload();
        if (!perms.length) {
          this.showSnackbar("Please enable at least one permission (Read/Write/Delete) for Web User.", "error");
          return false;
        }
      }

      // Check for duplicate role
      if (this.errorMessage) {
        this.showSnackbar(this.errorMessage, "error");
        return false;
      }

      return true;
    },

    // -------- roles list for duplicate check --------
    getAllCreatedUserRoles() {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      axios
        .post("/api/allCreatedUserRoles", { userId }, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => {
          const role = response.data.data;
          if (Array.isArray(role)) {
            this.userRolesCheckDetails.name = role.map((item) => item.role_type);
          }
        })
        .catch((error) => {
          console.error("Error fetching roles:", error);
        });
    },

    // -------- submit (FIXED: Improved payload structure) --------
    createNewRole() {
      if (!this.validateForm()) return;

      this.centerLoading = true;

      const userId = localStorage.getItem("userId"); // Keep as string, don't parse to int
      const token = localStorage.getItem("token");
      const userCategory = this.selectedUsers.join(", ");

      const permissions = this.buildPermissionsPayload();

      // Prepare payload based on user category
      let payload = {
        userId: parseInt(userId, 10), // Send as integer for backend validation
        userRoleType: this.selectedItem.user_role.trim(),
        userRoleDescription: this.selectedItem.user_role_description.trim(),
        userRoleCategory: userCategory,
        permissions: this.selectedUsers.includes("Web User") ? permissions : []
      };

      // Log payload for debugging
      console.log("Sending payload:", JSON.stringify(payload, null, 2));

      axios
        .post("/api/createUserRole", payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("Success response:", response.data);
          this.showSnackbar("User role created successfully!", "success");
          this.centerLoading = false;

          // Reset form data
          this.selectedUsers = [];
          this.selectedItem.user_role = "";
          this.selectedItem.user_role_description = "";
          this.errorMessage = "";

          // Reset permissions
          this.initializePermissionsStructure();

          // Refresh the roles list for duplicate check
          this.getAllCreatedUserRoles();

          // Navigate to user role list page after a short delay
          setTimeout(() => {
            this.$router.push('/user-role-list');
          }, 1500);
        })
        .catch((error) => {
          console.error("Error creating user role:", error);

          // Enhanced error handling
          if (error.response) {
            console.error("Response data:", error.response.data);
            console.error("Response status:", error.response.status);

            // Extract error message from response
            let errorMsg = "Failed to create user role.";
            if (error.response.data.message) {
              errorMsg = error.response.data.message;
            } else if (error.response.data.error) {
              errorMsg = error.response.data.error;
            } else if (typeof error.response.data === 'string') {
              errorMsg = error.response.data;
            }

            this.showSnackbar(errorMsg, "error");
          } else if (error.request) {
            console.error("No response received:", error.request);
            this.showSnackbar("No response from server. Please check your connection.", "error");
          } else {
            console.error("Error setting up request:", error.message);
            this.showSnackbar("Failed to create user role. Please try again.", "error");
          }

          this.centerLoading = false;
        });
    },

    backPageRoute() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../styles/user_management/create_user_role.scss" as *;
</style>